import { ChevronDown, Menu, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router";
import { TENDERS_ENABLED } from "~/lib/features";
import { useAuth } from "~/lib/hooks/use-auth";

const navLinks = [
	{ label: "Služby", href: "/#funkce" },
	{ label: "Ceník", href: "/cenik" },
	{ label: "O nás", href: "/o-nas" },
	{ label: "Kontakt", href: "/kontakt" },
];

const browseLinks = [
	...(TENDERS_ENABLED ? [{ label: "Veřejné zakázky", href: "/verejne-zakazky" }] : []),
	{ label: "Odvětví (NACE)", href: "/directory/odvetvi" },
	{ label: "Kraje", href: "/directory/kraj" },
];

export function Navbar() {
	const { user, loading } = useAuth();
	const [mobileOpen, setMobileOpen] = useState(false);

	return (
		<header className="sticky top-0 z-50 bg-surface/80 backdrop-blur-md border-b border-gray-100">
			<nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
				<Link to="/">
					<img src="/logo.png" alt="FirmIndex" className="h-10" />
				</Link>

				{/* Desktop nav */}
				<div className="hidden md:flex items-center gap-8">
					{navLinks.map((link) => (
						<Link
							key={link.href}
							to={link.href}
							className="text-sm font-medium text-muted hover:text-text transition-colors"
						>
							{link.label}
						</Link>
					))}
					{/* Browse dropdown */}
					<div className="group relative">
						<button
							type="button"
							className="flex items-center gap-1 text-sm font-medium text-muted hover:text-text transition-colors"
						>
							Procházet
							<ChevronDown className="h-3.5 w-3.5" />
						</button>
						<div className="invisible group-hover:visible opacity-0 group-hover:opacity-100 absolute top-full left-0 mt-2 w-44 rounded-2xl bg-card py-2 shadow-pop transition-all">
							{browseLinks.map((link) => (
								<Link
									key={link.href}
									to={link.href}
									className="block px-4 py-2 text-sm text-muted hover:bg-gray-50 hover:text-text transition-colors"
								>
									{link.label}
								</Link>
							))}
						</div>
					</div>
					{!loading &&
						(user ? (
							<Link
								to="/dashboard"
								className="rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-600 transition-colors"
							>
								Dashboard
							</Link>
						) : (
							<Link
								to="/login"
								className="rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-accent-600 transition-colors"
							>
								Přihlásit se
							</Link>
						))}
				</div>

				{/* Mobile toggle */}
				<button
					type="button"
					className="md:hidden p-2 text-muted hover:text-text"
					onClick={() => setMobileOpen(!mobileOpen)}
					aria-label={mobileOpen ? "Zavřít menu" : "Otevřít menu"}
				>
					{mobileOpen ? <X size={24} /> : <Menu size={24} />}
				</button>
			</nav>

			{/* Mobile menu */}
			{mobileOpen && (
				<div className="md:hidden border-t border-gray-100 bg-surface px-6 pb-6">
					{navLinks.map((link) => (
						<Link
							key={link.href}
							to={link.href}
							className="block py-3 text-sm font-medium text-muted hover:text-text"
							onClick={() => setMobileOpen(false)}
						>
							{link.label}
						</Link>
					))}
					<div className="border-t border-gray-100 mt-2 pt-2">
						<p className="py-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
							Procházet
						</p>
						{browseLinks.map((link) => (
							<Link
								key={link.href}
								to={link.href}
								className="block py-2 text-sm font-medium text-muted hover:text-text"
								onClick={() => setMobileOpen(false)}
							>
								{link.label}
							</Link>
						))}
					</div>
					{!loading &&
						(user ? (
							<Link
								to="/dashboard"
								className="mt-2 block rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary-600 transition-colors"
								onClick={() => setMobileOpen(false)}
							>
								Dashboard
							</Link>
						) : (
							<Link
								to="/login"
								className="mt-2 block rounded-full bg-accent-500 px-5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-accent-600 transition-colors"
								onClick={() => setMobileOpen(false)}
							>
								Přihlásit se
							</Link>
						))}
				</div>
			)}
		</header>
	);
}
